var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Logo'),(_vm.loading)?_c('Loading'):_vm._e(),(_vm.dataAvailable)?_c('div',[(_vm.items.length > 0)?_c('Faq',{attrs:{"items":_vm.items}}):_vm._e()],1):_vm._e(),(!_vm.dataAvailable && !_vm.loading)?_c('div',[_c('NoData')],1):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }